module.exports = __webpack_public_path__ + "img/flag.3012f0b5.svg";